import {COUNTRY_OPTIONS} from "constants/CountryConstants";

export const getCountryLabel = (codeCountry: string): string => {
  const country = COUNTRY_OPTIONS.find((element) => {
    return element?.value === codeCountry;
  });
  return country?.label ?? "-";
};
